<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="custom-scrollbar">
          <h3>Karierní plán</h3>
          <div v-if="!kredity_celkem.length && !vlastni_kredity.length">
            Nejsou žádní spolupracovníci k povýšení
          </div>
          
        <div v-if="kredity_celkem.length">
         <v-card class="pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
          <h4>Kredity ze struktury</h4>
        <v-data-table
          :headers="headers"
          :items="kredity_celkem"
          class="elevation-1"
          hide-actions
        >
         <template slot="items" slot-scope="props">
                  <td>{{ props.item.nazev_osoby }}</td>
                  <td>{{ props.item.pozice }}</td>
                  <td>{{ props.item.celkem_kredity | formatMoney }} kr.</td>
         </template>
        </v-data-table>
         </v-card>
        </div>
        
        
        <div v-if="vlastni_kredity.length">
        <v-card class="pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <h4>Vlastní kredity</h4>
        <v-data-table
          :headers="headers_vlastni"
          :items="vlastni_kredity"
          class="elevation-1"
          hide-actions
        >
         <template slot="items" slot-scope="props">
                  <td>{{ props.item.nazev_osoby }}</td>
                  <td>{{ props.item.pozice }}</td>
                  <td>{{ props.item.vlastni_kredity | formatMoney }} kr.</td>
         </template>
        </v-data-table>
        </v-card>
        </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      headers: [
        { text: 'Název osoby', value: 'nazev_osoby' },
        { text: 'Pozice', value: 'pozice' },
        { text: 'Kredity ze struktury', value: 'celkem_kredity' },
      ],
      headers_vlastni: [
        { text: 'Název osoby', value: 'nazev_osoby' },
        { text: 'Pozice', value: 'pozice' },
        { text: 'Vlastní kredity', value: 'vlastni_kredity' },
      ],
      kredity_celkem: [],
      vlastni_kredity: []
    }
  },
  watch: {},
  computed: {},
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      window.API.get("kariera/check").then(function(_body) {
        this.items = _body;
        console.log(this.items);
        this.kredity_celkem = this.items.kredity_celkem;
        this.vlastni_kredity = this.items.vlastni_kredity;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/KlientiSpolupracovnici/KarierniPlan.vue